import React from 'react';
import scrollToComponent from 'react-scroll-to-component';
import AWLogo from 'images/logo-green.svg';
import iconSun from 'images/sun.svg';
import iconFb from 'images/facebook.svg';
import iconInstagram from 'images/instagram.svg';
import iconTwitter from 'images/twitter.svg';
import iconTiktok from 'images/tiktok.svg';
import iconYoutube from 'images/youtube.svg';
import iconLinkedin from 'images/linkedin.svg';
import { StyledFooter, Container } from './styles';

class Footer extends React.Component {
  scrollToSection = (ref) => {
    scrollToComponent(document.getElementById(ref), { offset: 0, align: 'top', duration: 500 });
  }
  toggleWeChat = () => {
    this.setState({ wechat: !this.state.wechat });
  };
  render() {
    return (
      <StyledFooter>
        <Container>
          <div className="grid">
            <div className="upper-left">
              <img className="aw-logo" src={AWLogo} alt="aw" />
              <p className="desktop">Bangkok, Thailand <span className="bullet" /> 30 November - 1 December 2022 <span className="extend"><span className="bullet" /> <img src={iconSun} alt="sun" /> 28°C</span> </p>
              <p className="mobile">Bangkok, Thailand <span className="bullet" /> 30 Nov - 1 Dec 2022 <span className="extend"><span className="bullet" /> <img src={iconSun} alt="sun" /> 28°C</span> </p>
            </div>
            <div className="upper-right">
              <small>#AWasia</small>
              <div className="media">
                <a href="https://facebook.com/affiliateworldconferences" target="_blank" rel="noopener noreferrer"><img src={iconFb} alt="fb" /></a>
                <a href="https://instagram.com/AWConferences" target="_blank" rel="noopener noreferrer"><img src={iconInstagram} alt="ig" /></a>
                <a href="https://twitter.com/AWConferences" target="_blank" rel="noopener noreferrer"><img src={iconTwitter} alt="tw" /></a>
                <a href="https://tiktok.com/@awconferences" target="_blank" rel="noopener noreferrer"><img src={iconTiktok} alt="tk" /></a>
                <a href="https://youtube.com/affiliateworldconferences" target="_blank" rel="noopener noreferrer"><img src={iconYoutube} alt="yt" /></a>
                <a href="https://linkedin.com/company/affiliate-world-conferences" target="_blank" rel="noopener noreferrer"><img src={iconLinkedin} alt="li" /></a>
              </div>
              <button onClick={() => this.scrollToSection('banner')}>Back to top ↑</button>
            </div>
            <div className="divider" />
            <div className="lower-left">
              <a href="https://affiliateworldconferences.com/blog/" target="_blank" rel="noopener noreferrer">Blog</a><span className="bullet" />
              <a href="https://affiliateworldconferences.com/asia/terms-and-conditions/attendees/" target="_blank" rel="noopener noreferrer">Privacy Policy</a><span className="bullet" />
              <a href="https://affiliateworldconferences.com/asia/privacy-policy" target="_blank" rel="noopener noreferrer">Terms and Conditions</a><span className="bullet" />
              <a href="https://affiliateworldconferences.com/asia/cookie-declaration" target="_blank" rel="noopener noreferrer">Cookie Declaration</a><span className="bullet" />
              <span>Contact us at: <a href="mailto:info@awconf.com" target="_blank" rel="noopener noreferrer">info@awconf.com</a></span>
            </div>
            <div className="lower-right">
              <p>Affiliate World is brought to you by <span>iStack Conferences Ltd.</span></p>
            </div>
          </div>
        </Container>
      </StyledFooter>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js